<template>
  <div>
    <Top></Top>
    <!-- top content start -->
    <div class="content bgImgCss">
      <img :src="bgImg" alt class="imgSrcCss">
      <div class="contentPosition">
        <div class="contentTop">行业方案</div>
        <div class="contentBottom">
          <div>通用性智屏云管理架构，行业化场景应用</div>
        </div>
      </div>
    </div>
    <!-- top content end -->
    <!-- 面包屑 start -->
    <!-- <Bread :breadChild = toBreadChild></Bread> -->
    <!-- 面包屑 end -->
    <!-- <div class="contentBox">
      <div class="title">方案全景图</div>
      <div class="lineCss"></div>
    </div> -->
    <!-- start  -->
    <div class="floatBoxParent">
      <div class="floatBox">
        <div class="floatLeft">
          <img v-lazy="floatLeftImg1" alt class="leftImg">
          <img
            :src="toRightIcon"
            v-show="!changeRight1Bol"
            alt
            class="toRightIcon"
            @mouseover="yellowRight1"
             @click="toPage('Plan/PlanNewRestaurant')"
          >
          <img
            :src="toRightHei"
            v-show="changeRight1Bol"
            alt
            class="toRightIcon"
            @mouseout="heiRight1"
             @click="toPage('Plan/PlanNewRestaurant')"
          >
        </div>
        <div class="floatRight">
          <div class="rightTop"></div>
          <div class="rightTopTitle">新餐饮</div>
          <div class="lineCss"></div>
          
          <div class="rightTopText">
            在餐饮行业下，餐客要的是高效等餐、舒心用餐；商家希望高效售卖、提升坪效、增强客户黏性。我们的方案，从双方诉求出发，进行交叉分析，提供场景化新餐饮升级解决方案。
          </div>
        </div>
      </div>
    </div>
    <!-- end  -->
    <!-- start -->
    <div class>
      <div class="parentTwo">
        <div class="leftTwo">
          <div class="rightTop"></div>
          <div class="rightTopTitle">智慧门店</div>
          <div class="lineCss"></div>
          <div class="rightTopText rightTopTextTwo">
            智慧化门店建设，最关键的一环为全渠道打通，即打通线下门店与线上平台的数据链路。基于物联网、大数据分析等技术，通过线下门店的智屏硬件，实现线上线下一体化服务及运营。打造智能化、精准化的消费体验，并为品牌营销策略提供数据指导。
          </div>
        </div>
        <div class="rightTwo">
          <img
            :src="toLeftIcon"
            v-show="!changeLeft1Bol"
            alt
            class="toRightIcon"
            @click="toPage('Plan/PlanDetail')"
            @mouseover="yellowLeft1"
          >
          <img
            :src="toLeftHei"
            v-show="changeLeft1Bol"
            alt
            class="toRightIcon"
            @click="toPage('Plan/PlanDetail')"
            @mouseout="heiLeft1"
          >
          <img v-lazy="floatRightImg1" alt class="rightImg">
        </div>
      </div>
    </div>
    <!-- end -->
    <!-- start  -->
    <div class="floatBoxParent" style="margin-top:100px">
      <div class="floatBox">
        <div class="floatLeft">
          <img v-lazy="floatLeftImg2" alt class="leftImg">
          <img
            :src="toRightIcon"
            v-show="!changeRight2Bol"
            alt
            class="toRightIcon"
            @mouseover="yellowRight2"
            @click="toPage('Plan/PlanShowroom')"
          >
          <img
            :src="toRightHei"
            v-show="changeRight2Bol"
            alt
            class="toRightIcon"
            @mouseout="heiRight2"
            @click="toPage('Plan/PlanShowroom')"
          >
        </div>
        <div class="floatRight">
          <div class="rightTop"></div>
          <div class="rightTopTitle">智慧展厅</div>
          <div class="lineCss"></div>
          <div
            class="rightTopText"
          >智慧展厅，归根结底，是为了打造和渲染品牌影响力。通过智能大屏交互技术，与观者主动交互，提升观者参与感。在科技感十足的互动中，融入品牌元素，快速加强对品牌的认知。</div>
        </div>
      </div>
    </div>
    <!-- end  -->
    <!-- start -->
    <div class>
      <div class="parentTwo">
        <div class="leftTwo">
          <div class="rightTop"></div>
          <div class="rightTopTitle">新零售</div>
          <div class="lineCss"></div>
          <div
            class="rightTopText rightTopTextTwo"
          >新零售的升级通过智屏OS,实现全渠道数据链路的打通，不管线上线下，让顾客体会到同质、同价、同服务。在提升用户购物的同时，提升门店成交转换率。</div>
        </div>
        <div class="rightTwo">
          <img
            :src="toLeftIcon"
            v-show="!changeLeft2Bol"
            alt
            class="toRightIcon"
            @mouseover="yellowLeft2"
            @click="toPage('Plan/PlanNewRetail')"
          >
          <img
            :src="toLeftHei"
            v-show="changeLeft2Bol"
            alt
            class="toRightIcon"
            @mouseout="heiLeft2"
            @click="toPage('Plan/PlanNewRetail')"
          >
          <img v-lazy="floatRightImg2" alt class="rightImg">
        </div>
      </div>
    </div>
    <!-- end -->
    <!-- start  -->
    <div class="floatBoxParent" style="margin-top:100px">
      <div class="floatBox">
        <div class="floatLeft">
          <img v-lazy="floatLeftImg3" alt class="leftImg">
          <img
            :src="toRightIcon"
            v-show="!changeRight3Bol"
            alt
            class="toRightIcon"
            @mouseover="yellowRight3"
            @click="toPage('Plan/PlanCinemaDetail')"
          >
          <img
            :src="toRightHei"
            v-show="changeRight3Bol"
            alt
            class="toRightIcon"
            @mouseout="heiRight3"
            @click="toPage('Plan/PlanCinemaDetail')"
          >
        </div>
        <div class="floatRight">
          <div class="rightTop"></div>
          <div class="rightTopTitle">智慧影院</div>
          <div class="lineCss"></div>
          <div class="rightTopText">智慧影厅的建设，是通过打造科技感十足的互动体验，为影厅带来更多 线上线下流量，最终引导实现流量变现，为影厅带来更多利润空间。</div>
        </div>
      </div>
    </div>
    <!-- end  -->
    <!-- <div class="contentBox">
      <div class="title marginTop97">云服务搭建方案</div>
      <div class="lineCss"></div>
    </div> -->
    <!-- bottom start -->
    <!-- <div class="bottomBox">
      <div class="bottomLeft textRight">
        <img v-lazy="bottomLeftImg" alt>
      </div>
      <div class="bottomRight">
        <img v-lazy="bottomRightImg" alt>
      </div>
    </div>
    <div class="bottomBox bottomBoxTwo">
      <div class="bottomLeft">
        <div class="bottomTitle">数拓公有云</div>
        <div class="bottomText">适用于连锁商家，独立门店等所有商业</div>
      </div>
      <div class="bottomRight">
        <div class="bottomTitle">品牌私有云</div>
        <div class="bottomText">适用于业务体系复杂，门店覆盖面广泛，对信息私密度要求极高的企业，如政府类、国有企业等</div>
      </div>
    </div> -->
    

    <!-- bottom end  -->
    <Footer></Footer>
  </div>
</template>
<script>
import Top from "@/components/top.vue";
import Footer from "@/components/footer.vue";
import bgImg from "@/assets/images/fangAnTop.png";
import floatLeftImg1 from "@/assets/images/floatLeftImg1.png";
import floatLeftImg2 from "@/assets/images/floatLeftImg2.png";
import floatLeftImg3 from "@/assets/images/floatLeftImg3.png";

import floatRightImg1 from "@/assets/images/floatRightImg1.png";
import floatRightImg2 from "@/assets/images/floatRightImg2.png";

import toRightIcon from "@/assets/images/toRightIcon.png";
import toLeftIcon from "@/assets/images/toLeftIcon.png";
import bottomLeftImg from "@/assets/images/bottomLeftImg.png";
import bottomRightImg from "@/assets/images/bottomRightImg.png";

import toRightHei from "@/assets/images/toRightHei.png";
import toLeftHei from "@/assets/images/toLeftHei.png";

import Bread from "@/components/bread.vue";

export default {
  name: "Plan",
  components: {
    Top,
    Footer,
    Bread
  },
  data() {
    return {
      toBreadChild: ["方案"],
      bgImg: bgImg,
      floatLeftImg1: floatLeftImg1,
      toRightIcon: toRightIcon,
      toLeftIcon: toLeftIcon,
      floatRightImg1: floatRightImg1,
      floatLeftImg2: floatLeftImg2,
      floatLeftImg3: floatLeftImg3,
      floatRightImg2: floatRightImg2,
      bottomLeftImg: bottomLeftImg,
      bottomRightImg: bottomRightImg,
      toRightHei: toRightHei,
      toLeftHei: toLeftHei,
      // 控制箭头的hover效果
      changeRight1Bol: false,
      changeRight2Bol: false,
      changeRight3Bol: false,
      changeLeft1Bol: false,
      changeLeft2Bol: false
    };
  },
  methods: {
    toPage(val) {
       let routeUrl = this.$router.resolve({
        path: `${val}`
      });
      window.open(routeUrl.href, "_blank");
    },
    changeRight1() {},
    // 向右箭头的hover
    yellowRight1() {
      this.changeRight1Bol = true;
    },
    heiRight1() {
      this.changeRight1Bol = false;
    },
    yellowRight2() {
      this.changeRight2Bol = true;
    },
    heiRight2() {
      this.changeRight2Bol = false;
    },
    yellowRight3() {
      this.changeRight3Bol = true;
    },
    heiRight3() {
      this.changeRight3Bol = false;
    },
    // 向左箭头的hover
    yellowLeft1() {
      this.changeLeft1Bol = true;
    },
    heiLeft1() {
      this.changeLeft1Bol = false;
    },
    yellowLeft2() {
      this.changeLeft2Bol = true;
    },
    heiLeft2() {
      this.changeLeft2Bol = false;
    }
  }
};
</script>
<style scoped>
/* start */
.content {
  position: relative;
  font-size: 0;
}

.bgImgCss {
  width: 100%;
  /* height: 788px; */
}

.imgSrcCss {
  width: 100%;
}

.contentPosition {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 660px;
  height: 90px;
  text-align: center;
}

.contentTop {
  font-size: 8.7rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  margin-bottom: 37px;
}

.contentBottom {
  width: 660px;
  text-align: center;
  font-size: 3rem;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  line-height: 45px;
}

/* end  */
.contentBox {
  text-align: center;
}

.lineCss {
  width: 80px;
  height: 4px;
  background: rgba(252, 200, 0, 1);
  margin-top: 24px;
  margin-bottom: 43px;
  margin-top: 22px;
}

.title {
  font-size: 4rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  margin-top: 11%;
}

.floatBox::after {
  content: "";
  display: block;
  clear: both;
}

.floatBoxParent {
  background: rgba(240, 240, 240, 1);
}

.floatBox {
  padding: 53px 0 75px;
  width: 70%;
  margin: auto;
}

.floatLeft {
  width: 48%;
  float: left;
  text-align: right;
  font-size: 0;
}

.floatRight {
  width: 48%;
  float: right;
}

.rightTop {
  font-size: 2.9rem;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(0, 0, 0, 1);
  margin-top: 22%;
}

.rightTopTitle {
  font-size: 4rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  margin-top: 24px;
}

.rightTopText {
  height: 81px;
  width: 80%;
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 30px;
  margin-top: 15%;
}

.toRightIcon {
  width: 20%;
  max-width: 70px;
  cursor: pointer;
}

.leftImg {
  width: 80%;
  max-width: 517px;
}

.parentTwo::after {
  content: "";
  display: block;
  clear: both;
}

.parentTwo {
  width: 70%;
  margin: auto;
  padding: 100px 0 0;
}

.leftTwo {
  width: 44%;
  float: left;
  padding-left: 4%;
}

.rightTwo {
  width: 48%;
  float: right;
  font-size: 0;
}

.rightImg {
  width: 80%;
  max-width: 517px;
}

.rightTopTextTwo {
  width: 90%;
}

.marginTop97 {
  margin-top: 97px;
}

.bottomBox::after {
  content: "";
  display: block;
  clear: both;
}

.bottomBox {
  width: 80%;
  margin: auto;
  margin-top: 73px;
}

.bottomLeft {
  width: 49%;
  float: left;
}
.bottomLeft img{
  width: 100%;
  max-width: 589px;
}
.bottomRight img{
  width: 100%;
  max-width: 589px;
}
.textRight {
  text-align: right;
}



.bottomRight {
  width: 49%;
  float: right;
}

.bottomTitle {
  font-size: 3.2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  text-align: center;
  margin-top: 47px;
}

.bottomText {
  width: 90%;
  margin: auto;
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 30px;
  text-align: center;
  margin-top: 18px;
}

.bottomBoxTwo {
  width: 80%;
  margin: auto;
  padding-bottom: 73px;
}

.toRightIcon:hover {
}
@media screen and (max-width: 1125px) {
  .bottomBoxTwo {
    width: 80%;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Plan.vue